<script>
  let provincesData = []
  let provinces = true
  import Loading from './components/Loading.svelte'
  import { setContext } from 'svelte'
  import InlinePromo from './InlinePromo.svelte'
  import ProvincesTable from './components/ProvincesTable.svelte'
  import ProvincesCharts from './ProvincesCharts2.svelte'
  import Table from './Table.svelte'
  import VaxHospitals from './VaxHospitals.svelte'
  import {
    formatThousands,
    formatMillions,
    parseTime,
    formatDateFull,
  } from './functions'
  import CumulativeChart from './CumulativeChart.svelte'
  import CumulativeChartDays from './CumulativeChartDays.svelte'
  import DailyChart from './DailyChart.svelte'
  import Calculator from './Calculator.svelte'
  import VaxCasesChart from './VaxCasesChart.svelte'
  import CompareWaves from './CompareWaves.svelte'
  import WaveComparison from './WaveComparison.svelte'
  import { randomInt } from '@mediahackza/utilities'

  async function getProvincesData() {
    let ri = randomInt(1000, 100000000)
    await fetch(`https://coronavirus.mediahack.co.za/api/provinces.php?r=${ri}`)
      .then((response) => response.json())
      .then((data) => {
        provincesData = data
      })
  }

  let theCurrentData = []
  let margin = { top: 30, right: 10, bottom: 30, left: 50 }
  let data
  let national = []
  let cumulative = []
  let jandjTotal = 0
  let pfizerTotal = 0
  let jandjTotalSisonke = 0
  let currentSevenDay = 0
  let previousSevenDay = 0
  let sevenDayDifference = 0
  let sevenDayDifferenceAbs = 0
  let sevenDayText = 'fewer doses than'
  let vaccineTotal = 0

  // set contet data and functions
  let nData = () => national
  let cData = () => cumulative

  setContext('chart', { nData, cData, margin })

  $: jandjPercent = (jandjTotal / vaccineTotal) * 100
  $: pfizerPercent = (pfizerTotal / vaccineTotal) * 100
  let updateDate = ''

  async function getCumulative() {
    let ri = randomInt(1000, 100000000)
    const url = `https://coronavirus.mediahack.co.za/api/national.php?r=${ri}`
    await fetch(url)
      .then((response) => response.json())
      .then((response) => {
        response.forEach((d, i) => {
          d.id = i
          let newDate = d.date.split('-')
          newDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0]
          d.refDate = newDate
          d.date = parseTime(newDate)
        })
        cumulative = response
      })
  }

  async function getData() {
    let ri = randomInt(1000, 100000000)
    const res = await fetch(
      `https://coronavirus.mediahack.co.za/api/vaccinations.php?r=${ri}`
    )
    data = await res.json()

    data.forEach((d) => {
      d.seven_day_average = +d.seven_day_average
      d.Date = parseTime(d.Date)
      d.total_vaccinations = +d.total_vaccinations
      d.daily_vaccinations = +d.daily_vaccinations
      d.fully_vaccinated =
        +d.JnJ_vaccines + +d.Pfizer_second_dose + +d.Sisonke_JnJ_total
    })
    national = data.filter((d, i) => d.Location === 'South Africa')
    theCurrentData = national[0]
    updateDate = formatDateFull(national[0].Date)

    vaccineTotal = +national[0].total_vaccinations
    jandjTotal = +national[0].total_jandj
    pfizerTotal = +national[0].Pfizer_total
    jandjTotalSisonke = +national[0]['Sisonke_JnJ_total']
    // vaccineTotal = +national[0].fully_vaccinated
    currentSevenDay = (+national[0].seven_day_average).toFixed(0)
    previousSevenDay = (+national[6].seven_day_average).toFixed(0)
    sevenDayDifference = currentSevenDay - previousSevenDay
    sevenDayDifferenceAbs = Math.abs(sevenDayDifference)
    if (sevenDayDifference > 0) {
      sevenDayText = 'more doses than'
    }
  }

  let promise = Promise.all([getData(), getCumulative(), getProvincesData()])
  // let promise = getData()
</script>

<main>
  <!-- <section>
    <div class="update-date">
      The page is updated daily. Last updated: {updateDate}
    </div>
  </section> -->
  <!-- <section><InlinePromo /></section> -->

  <section>
    {#await promise}
      <Loading />
    {:then}
      <Table />
    {/await}
  </section>

  <!-- <div class="disclaimer">
    We're in the process of moving some of the charts and data from our <a
      href="http://mediahack.co.za/datastories/coronavirus/dashboard/"
      target="_blank">main Coronavirus dashboard</a
    > to this site. The provincial section will be updated in the coming next while.
  </div> -->
  <!-- Provinces table -->
  <section>
    {#await promise}
      <Loading />
    {:then}
      <ProvincesTable {provincesData} />
    {/await}
  </section>

  <section>
    {#await promise}
      <Loading />
    {:then}
      <ProvincesCharts />
    {/await}
  </section>

  <!-- <div class="section-spacer" /> -->

  <!-- Daily cases and averages -->
  <section>
    {#await promise}
      <Loading />
    {:then}
      <VaxCasesChart />
    {/await}
  </section>

  <!-- Wave Comparison -->
  <section>
    {#await promise}
      <Loading />
    {:then}
      <WaveComparison />
    {/await}
  </section>

  <!-- Vaccinations versus hospitlisation -->
  <section>
    {#await promise}
      <Loading />
    {:then}
      <VaxHospitals />
    {/await}
  </section>

  <section>
    <p>
      South Africa's first Covid-19 vaccinations started on <span
        class="highlight">18 February 2021</span
      >
      with the Sisonke trial, which used the Johnson & Johnson vaccine. The official
      vaccination rollout started on
      <span class="highlight">17 May 2021</span> with those over 60 years old.
    </p>
    South Africa is currently using two vaccines: the single-dose Johnson & Johnson
    and the two-dose Pfizer vaccine.
    <p />
  </section>

  <section>
    {#await promise}
      <Loading />
    {:then}
      <div class="chart-title">Vaccines Used</div>
      <div class="vaccination-current chart-block">
        <div class="vaccination-type">
          <div class="vaccination-name">Johnson & Johnson</div>
          <div class="vaccination-value">
            <div class="jjbar" style="width: {jandjPercent}%">
              {formatThousands(jandjTotal)}
            </div>
          </div>
          <div class="vaccination-name">Pfizer</div>
          <div class="vaccination-value">
            <div class="pfbar" style="width: {pfizerPercent}%">
              {formatThousands(pfizerTotal)}
            </div>
          </div>
        </div>
      </div>
    {/await}
  </section>
  <section class="top-spacer">
    <p>
      To date a total of <span class="highlight"
        >{formatMillions(vaccineTotal)} vaccines</span
      >
      have been administered.
      <span class="highlight">{formatMillions(jandjTotal)}</span> of these are
      the single-dose Johnson & Johnson vaccine and
      <span class="highlight">{formatMillions(pfizerTotal)}</span> two-dose Pfizer
      vaccines.
    </p>
  </section>

  <!-- CUMULATIVE CHART -->
  <section>
    {#await promise}
      <Loading />
    {:then}
      <CumulativeChart />
    {/await}
  </section>

  <!-- DAILY CHART -->
  <section>
    <p>
      South Africa is currently performing an average of <span class="highlight"
        >{formatThousands(currentSevenDay)} doses per day</span
      >
      (seven-day average). This is
      <span class="highlight"
        >{formatThousands(sevenDayDifferenceAbs)}
        {sevenDayText}</span
      >
      last week's average of
      <span class="highlight">{formatThousands(previousSevenDay)}</span>.
    </p>
  </section>
  <section>
    {#await promise}
      <Loading />
    {:then}
      <DailyChart />
    {/await}
  </section>

  <section>
    <p>
      Government's initial target was to <a
        href="https://www.gov.za/covid-19/vaccine/strategy"
        target="_new">vaccinate 67%</a
      >
      of the population. That is approximately
      <span class="highlight">40&nbsp;million people</span>.
    </p>
    <p>
      South Africa is using two vaccines, the single-dose Johnson & Johnson and
      the two-dose Pfizer. Based on the current weekly average of vaccinations
      being performed this is how long it will take to vaccinate 40 million
      South Africans:
    </p>
  </section>

  <section>
    {#await promise}
      <p><img src="assets/loading.svg" alt="loader" /></p>
    {:then}
      <Calculator nationalData={national} />
    {/await}
  </section>

  <!-- CUMULATIVE CHART DAYS -->
  <section>
    {#await promise}
      <p><img src="assets/loading.svg" alt="loader" /></p>
    {:then}
      <CumulativeChartDays />
    {/await}
  </section>

  <!-- Cimpare Waves -->
  <section>
    {#await promise}
      <Loading />
    {:then}
      <CompareWaves />
    {/await}
  </section>
</main>

<style>
  .promo {
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
    font-weight: 700;
    font-size: 1.1rem;
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
  }
  .promo a {
    color: #b92c2d;
  }
  .promo img {
    width: 100%;
  }
  .chart-block {
    width: 100%;
  }
  main {
    text-align: center;
    max-width: 700px;
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 60px;
  }
  .vaccination-type {
    display: grid;
    grid-template-columns: 1fr 3fr;
    grid-gap: 4px;
  }
  .vaccination-name,
  .vaccination-value {
    text-align: left;
  }
  .vaccination-name {
    text-transform: uppercase;
    text-align: right;
    padding: 0px;
  }
  .vaccination-value {
    border: none;
  }
  .jjbar,
  .pfbar {
    background: lightgray;
    padding: 0px 5px;
    color: #fff;
    transition: width 1s;
    width: 0px;
    background: var(--blue700);
    color: #fff;
  }

  .update-date {
    font-style: italic;
  }

  @media (min-width: 640px) {
  }
  button {
    padding: 10px 20px;
    border-radius: 10px;
    border: none;
    margin-bottom: 10px;
    margin-top: 20px;
    background: #568584;
    color: #fff;
    cursor: pointer;
  }
</style>
